//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useImage } from '~/composables';
import { getStoryLinkPath } from '~/modules/storyblok/helpers/getStoryLinkPath';

export default defineComponent({
  props: ['blok'],
  setup({ blok }) {
    const { imageSizes } = useImage();

    const productSizes = computed(() => {
      const productWidth = imageSizes.productCard?.width || 0;
      return {
        width: blok.wide ? productWidth * 2 : productWidth,
        height: imageSizes.productCard?.height || null,
      };
    });

    return { productSizes, getStoryLinkPath };
  },
});
